import { ReactElement, ReactNode } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../store/store";

/** Avoid legacy UI flash while /config loads; then route preview vs legacy. */
export function AiMatchingRouteGate({
  preview,
  legacy,
}: {
  preview: ReactNode;
  legacy: ReactNode;
}): ReactElement {
  const configLoaded = useSelector((state: RootState) => state.config.configLoaded);
  const aiMatchingPreview = useSelector((state: RootState) => state.config.aiMatchingPreview);

  if (!configLoaded) {
    return (
      <div className="config-route-gate" aria-busy="true" aria-label="Loading">
        <div className="config-route-gate__spinner" />
      </div>
    );
  }

  return <>{aiMatchingPreview ? preview : legacy}</>;
}
